// To avoid sending the user to random locations, use a whitelist
const KNOWN_REDIRECT_DOMAINS = ['pepperhq.com'];

const isKnownDomain = (hostname: string): boolean =>
    KNOWN_REDIRECT_DOMAINS.some(domain => hostname === domain || hostname.endsWith(`.${domain}`));

/**
 * Guard a `redirectTo` value against open-redirect abuse.
 *
 * - Internal absolute paths (`/foo/bar`) are always allowed.
 * - External absolute URLs are allowed only when their host is a known/trusted domain.
 * - Protocol-relative (`//host`, `/\host`) and any other/external value returns the fallback.
 */
export const getSafeExternalRedirect = (redirectTo: string | null | undefined, fallback: string): string => {
    if (!redirectTo) {
        return fallback;
    }
    // Internal absolute path - reject protocol-relative forms that resolve off-origin.
    if (redirectTo.startsWith('/') && !redirectTo.startsWith('//') && !redirectTo.startsWith('/\\')) {
        return redirectTo;
    }
    // Absolute URL - only allow if it targets a known domain.
    try {
        const { hostname } = new URL(redirectTo);
        if (isKnownDomain(hostname)) {
            return redirectTo;
        }
    } catch {
        // Not a parseable absolute URL - fall through to the fallback.
    }
    return fallback;
};
